import { render } from "./ComparativeChart.vue?vue&type=template&id=5f8e2140"
import script from "./ComparativeChart.vue?vue&type=script&lang=js"
export * from "./ComparativeChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__